import React from 'react';
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from '../ui/card';
import { Badge } from '../ui/badge';
import {
  Table, TableBody, TableCell, TableHead, TableHeader, TableRow
} from '../ui/table';
import { FileText, Loader2 } from 'lucide-react';

export function DocumentsListTab({ documents, loadingDocs, getStatusBadge, getFileIcon }) {
  return (
    <Card>
      <CardHeader>
        <CardTitle>Processed Documents</CardTitle>
        <CardDescription>History of all uploaded and processed documents</CardDescription>
      </CardHeader>
      <CardContent>
        {loadingDocs ? (
          <div className="flex items-center justify-center py-8">
            <Loader2 className="h-6 w-6 animate-spin text-muted-foreground" />
          </div>
        ) : documents.length === 0 ? (
          <div className="text-center py-8 text-muted-foreground">
            <FileText className="h-12 w-12 mx-auto mb-4 opacity-50" />
            <p>No documents processed yet</p>
            <p className="text-sm">Upload your first document to get started</p>
          </div>
        ) : (
          <Table>
            <TableHeader>
              <TableRow>
                <TableHead>File</TableHead>
                <TableHead>Type</TableHead>
                <TableHead>Status</TableHead>
                <TableHead>Uploaded</TableHead>
                <TableHead>Items</TableHead>
              </TableRow>
            </TableHeader>
            <TableBody>
              {documents.map((doc) => (
                <TableRow key={doc.id} data-testid={`doc-row-${doc.id}`}>
                  <TableCell>
                    <div className="flex items-center gap-2">
                      {getFileIcon(doc.mime_type)}
                      <span className="font-medium">{doc.filename}</span>
                    </div>
                  </TableCell>
                  <TableCell>
                    <Badge variant="outline">
                      {doc.document_type === 'inquiry' ? 'Inquiry' : 'Purchase Order'}
                    </Badge>
                  </TableCell>
                  <TableCell>{getStatusBadge(doc.processing_status)}</TableCell>
                  <TableCell>
                    {new Date(doc.uploaded_at).toLocaleDateString()}
                  </TableCell>
                  <TableCell>
                    {doc.document_type === 'inquiry' 
                      ? `${doc.draft_parts?.length || 0} parts`
                      : doc.draft_order_id ? '1 order' : '-'}
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        )}
      </CardContent>
    </Card>
  );
}
